import { format } from 'date-fns';
import { MEDIA_TYPE } from '@constants/file';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PhoneIcon from '@mui/icons-material/Phone';

export const hasMessageContent = msg => typeof msg === 'string' && msg.trim().length > 0;

export const hasMediaContent = mediaList => Array.isArray(mediaList) && mediaList.some(m => m?.link);

export const isImage = item => item?.type === MEDIA_TYPE.IMAGE;

export const isVideo = item => item?.type === MEDIA_TYPE.VIDEO;

export const toHandle = (name, maxLength = 30) =>
    (name || '')
        .toLowerCase()
        .replace(/\s+/g, '_')
        .replace(/[^a-z0-9._]/g, '')
        .slice(0, maxLength) || 'your_page';

export const handleFromUrl = url => {
    const raw = String(url || '').trim();
    if (!raw) return '';
    const absolute = /^https?:\/\//i.test(raw) ? raw : `https://${raw}`;
    let pathname;
    try {
        ({ pathname } = new URL(absolute));
    } catch {
        return '';
    }
    const segments = pathname.split('/').filter(Boolean);
    return segments.length ? segments[segments.length - 1].replace(/^@/, '') : '';
};

export const truncate = (text, limit) => {
    if (!text || text.length <= limit) return { shown: text || '', truncated: false };
    return { shown: `${text.slice(0, limit)}…`, truncated: true };
};

export const formatPostDate = date => {
    if (!date) return '';
    try {
        const d = date instanceof Date ? date : new Date(date);
        if (Number.isNaN(d.getTime())) return '';
        return format(d, 'MMM d, yyyy');
    } catch {
        return '';
    }
};

// 0 (none) is intentionally absent; callers treat undefined as "no CTA".
export const GOOGLE_CTA = {
    1: { labelKey: 'SocialPosts.book', Icon: CalendarTodayIcon },
    2: { labelKey: 'SocialPosts.orderOnline', Icon: ShoppingCartIcon },
    3: { labelKey: 'SocialPosts.buy', Icon: ShoppingBagIcon },
    4: { labelKey: 'common.learnMore', Icon: InfoOutlinedIcon },
    5: { labelKey: 'SocialPosts.signUp', Icon: PersonAddIcon },
    6: { labelKey: 'SocialPosts.callNow', Icon: PhoneIcon },
};
